import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'bb-icon-page-ui',
    templateUrl: './bb-icon-page-ui.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class IconPageComponent {}
